import { Download } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import MUIDownloadFile from '../form-fields/fields/MUIDownloadFile';

import { get, set } from 'lodash';
import { PostRecord } from '../../../../lib/api/PostRecord';
import PutRecord from '../../../../lib/api/PutRecord';
import { APIS } from '../../../../lib/constants/apis';
import { STRAPI_URL } from '../../../../lib/constants/url';
import { DisplayDateTime } from '../../../../utils/formats';

interface BescheidDownloadProps {
	bescheidPath: string;
	bescheidDownloadOnPath: string;
	bescheidDownloadStrapiFieldName: string;
	apiName: string;
	apiObjectId: number;
	statischeVorlagenPath?: string;
	externesSchreibensPath?: string;
	extraFilesPath?: string;
	useSingleButtonVariant?: boolean;
}

//useSingleButtonVariant only for cases where only one file is expected to be downloaded, since it uses a different UI variant. In case of multiple files (or also single files), the default MUIDownloadFile table variant should be used.
const BescheidDownload: FC<BescheidDownloadProps> = ({
	bescheidPath,
	bescheidDownloadOnPath,
	bescheidDownloadStrapiFieldName,
	apiName,
	apiObjectId,
	statischeVorlagenPath = '',
	externesSchreibensPath = '',
	extraFilesPath = '',
	useSingleButtonVariant = false,
}) => {
	const { application, saveApplication } = useApplication();

	console.log({ statischeVorlagenPath, externesSchreibensPath, extraFilesPath });

	const updateBescheidDownloadedOnField = async () => {
		let appCopy = cloneDeep(application);
		if (get(appCopy, bescheidDownloadOnPath, '') === null || get(appCopy, bescheidDownloadOnPath, '') === '') {
			set(appCopy, bescheidDownloadStrapiFieldName, new Date());

			try {
				await PutRecord(apiName, apiObjectId, { data: { [bescheidDownloadStrapiFieldName]: new Date() } });
				await PostRecord(APIS.PushNotificaiton, { data: { entities: [{ api: apiName, api_suffix: 'Foerderbescheid', id: apiObjectId }] } });
				saveApplication(false, appCopy);
			} catch (err: any) {
				console.error('ERROR: Update Bescheid heruntergeladen am ', err);
			}
		}
		await fetchFile(get(appCopy, `${bescheidPath}.attributes.url`), get(appCopy, `${bescheidPath}.attributes.name`));
	};

	const fetchFile = async (url: string, fileName: string = '') => {
		try {
			// Private file URLs need the /api/files prefix so the accessToken cookie (path: '/api') is sent
			const fileUrl = url.startsWith('/private/') ? `${STRAPI_URL}/api/files${url}` : `${STRAPI_URL}${url}`;
			let res = await fetch(fileUrl, {
				credentials: 'include',
			});

			const blob = await res.blob();
			const objectUrl = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(objectUrl);
		} catch (err: any) {
			console.error(' ERROR: Downloading File ', err);
		}
	};
	const fileName = get(application, `${bescheidPath}.attributes.name`, '');
	const fileUrl = get(application, `${bescheidPath}.attributes.url`, '');
	const downloadedOn = get(application, bescheidDownloadOnPath, null);

	return (
		<>
			<Typography>Hier können Sie Ihren Bescheid herunterladen:</Typography>
			{useSingleButtonVariant ?
				<>
					{fileUrl && (
						<Button variant='outlined' startIcon={<Download />} sx={{ mt: 2, mb: 1 }} onClick={() => updateBescheidDownloadedOnField()}>
							{fileName}
						</Button>
					)}
					{downloadedOn && <Typography variant='body2'>Heruntergeladen am: {DisplayDateTime(downloadedOn)}</Typography>}
				</>
			:	<MUIDownloadFile
					fileMetaData={get(application, bescheidPath, {})}
					onDownload={updateBescheidDownloadedOnField}
					downloadedOn={downloadedOn}
					showDownloadButton={true}
				/>
			}
		</>
	);
};

export default BescheidDownload;
